<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import {mapMutations} from 'vuex';
export default {
  name: "App",
  mounted() {
    // this.getAgreenment();
    this.getCompanyInfo();
  },
  methods: {
    ...mapMutations({
      SET_AGREEN: 'SET_AGREEN',
      SET_COMPANY: 'SET_COMPANY'
    }),
    async getAgreenment() {
      await this.$axios.post(this.$http.api + '/v1/agreement/getagreements').then(res => {
        if (!res.code) {
          this.SET_AGREEN(res.data);
        }
      })
    },
    async getCompanyInfo() {
      await this.$axios.post(this.$http.api + '/v1/community/mrocompanyinfo').then(res => {
        if (!res.code) {
          this.SET_COMPANY(res.data);
        }
      });
    }
  }
};
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue